module.exports = __webpack_public_path__ + "img/grc_icono.90275ce1.svg";